import { fa } from 'vuetify/lib/locale'

export default {
  ...fa,

  components: {
    copyRight: {
      copyRight: 'تمامی حقوق برای دیما محفوظ است \u00A9 1399'
    },
    passwordVerification: {
      title: 'تایید کلمه عبور فعلی',
      password: 'کلمه عبور',
      passwordPlaceholder: '********',
      buttonTitle: 'تایید کلمه عبور',
      passwordRequired: 'کلمه عبور فعلی الزامی‌است',
      passwordValidation: 'حداقل تعداد کاراکتر مجاز کلمه عبور 8 کاراکتر می‌باشد'
    },
    formHelpBox: {
      send: 'ارسال'
    },
    login: {
      email: 'پست الکترونیک',
      password: 'کلمه عبور',
      login: 'ورود',
      rememberMe: 'مرا به خاطر بسپار',
      forgotPassword: 'کلمه عبور را فراموش کرده اید!',
      notRegister: 'هنوز ثبت نام نکرده اید!',
      register: 'ثبت نام کنید',
      emailPlaceholder: 'email@example.com',
      passwordPlaceholder: '********',
      passwordRequired: 'کلمه عبور الزامی است',
      emailRequired: 'پست الکترونیکی الزامی است',
      passwordValidation: 'حداقل تعداد کلمه عبور 8 کاراکتر است',
      emailValidation: 'فرمت پست الکترونیکی صحیح نیست'
    },
    register: {
      title: 'ثبت نام',
      password: 'کلمه عبور',
      register: 'ادامه و تایید پست الکترونیکی',
      login: 'وارد شوید',
      haveAccount: 'حساب کاربری دارید؟',
      legalPerson: 'شخص حقوقی',
      realPerson: 'شخص حقیقی',
      phoneNumber: 'شماره موبایل',
      email: 'پست الکترونیک',
      emailPlaceholder: 'email@example.com',
      name: 'نام',
      nameRequired: 'نام الزامی است',
      lastName: 'نام خانوادگی',
      lastNameRequired: 'نام خانوادگی الزامی است',
      rules: 'با قوانین و مقررات موافقم',
      rulesRequired: 'پذیرش قوانین و مقررات الزامی است',
      passwordInvalid: 'حداقل تعداد کاراکتر برای کلمه عبور 8 کاراکتر است',
      passwordPlaceholder: '********',
      phoneNumberPlaceholder: '**** *** **09',
      passwordRequired: 'کلمه عبور الزامی است',
      phoneNumberRequired: 'شماره موبایل الزامی است',
      emailRequired: 'پست الکترونیکی الزامی است',
      passwordValidation: 'حداقل تعداد کاراکتر برای کلمه عبور ۸ کاراکتر است',
      emailValidation: 'فرمت پست الکترونیکی اشتباه است',
      emailStatus: 'پست الکترونیکی شما به عنوان نام کاربری بوده و غیر قابل تغییر است',
      phoneNumberValidation: 'فرمت شماره موبایل اشتباه است',
      phoneNumberCountValidation: 'شماره موبایل باید 11 رقمی باشد',
      nameValidation: 'لطفا نام را با حروف فارسی وارد کنید',
      lastNameValidation: 'لطفا نام خانوادگی را با حروف فارسی وارد کنید'
    },
    forgotPassword: {
      title: 'بازیابی کلمه عبور',
      email: 'پست الکترونیکی',
      back: 'لغو',
      passwordRecovery: 'بازیابی کلمه عبور',
      notRegister: 'هنوز ثبت نام نکرده اید ! ',
      register: 'ثبت نام کنید',
      emailPlaceholder: 'email@example.com',
      passwordRecoveryDetails: 'لینک بازیابی کلمه عبور به پست الکترونیک شما ارسال شده است . برای تغییر کلمه عبور لطفا به توضیحاتی که در پست الکترونیک آمده است توجه کنید .',
      changePassword: 'تغییر کلمه عبور',
      newPassword: 'کلمه عبور جدید',
      repeatNewPassword: 'تکرار کلمه عبور جدید',
      passwordPlaceholder: '********',
      emailRequired: 'پست الکترونیکی الزامی است',
      emailValidation: 'فرمت پست الکترونیکی صحیح نیست'
    },
    changePassword: {
      title: 'تغییر گذرواژه',
      changePassword: 'تغییر کلمه عبور',
      newPassword: 'کلمه عبور جدید',
      repeatNewPassword: 'تکرار کلمه عبور جدید',
      passwordPlaceholder: '********',
      passwordRequired: 'کلمه عبور جدید الزامی است',
      newPasswordRequired: 'تکرار کلمه عبور جدید الزامی است',
      passwordValidation: 'حداقل تعداد کاراکتر برای کلمه عبور 8 کاراکتر است',
      newPasswordValidation: 'کلمه عبور با تکرار کلمه عبور یکسان نیست'
    },
    filterBox: {
      fromDate: 'از تاریخ',
      toDate: 'تا تاریخ',
      buttonText: 'فیلتر کردن'
    },
    underConstruction: {
      title: 'در حال ساخت',
      description: 'این بخش در حال ساخت میباشد.'
    },
    formItem: {
      selectAllPlaceholder: 'انتخاب همه'
    },
    formItemFileInput: {
      selectLabel: 'انتخاب فایل'
    }
  },
  pages: {
    confirmModal: {
      title: 'مودال تایید اطلاعات',
      confirmTitle: 'آیا از حذف آیتم مورد نظر مطمئن می‌باشید؟',
      confirmMessage: 'با حذف این گزینه دیگر امکان دسترسی به اطلاعات حذف شده نمی باشد',
      confirm: 'بله، مطمئن هستم',
      cancel: 'انصراف',
      showModal: 'نمایش مودال'
    },
    admin: {
      title: 'صفحات مدیریت'
    },
    passwordVerification: {
      title: 'تایید گذر واژه فعلی'
    },
    formHelpBox: {
      title: 'صفحه راهنمایی'
    },
    portal: {
      title: 'پرتال'
    },
    server: {
      title: 'سرور'
    },
    stepper: {
      title: 'گام شمار',
      formNameLabel: 'نام کمپین',
      formNamePlaceholder: 'نام',
      formNameRuleRequired: 'نام الزامی می باشد',
      formNameRuleMaxLength: 'حداکثر تعداد کاراکتر مجاز ۱۰ می باشد',
      formDescLabel: 'شرح کمپین',
      formDescPlaceholder: 'توضیحات',
      formAgreeLabel: 'تایید',
      formAgreementRuleRequired: 'قبول شرایط الزامی است',
      startButtonText: 'ثبت کمپین',
      nextButtonText: 'ادامه',
      previousButtonText: 'مرحله قبل',
      finishButtonText: 'ثبت کمپین',
      step1: 'مرحله اول',
      step2: 'تکمیل مشخصات',
      step3: 'مرحله پایانی',
      tableHeader: {
        name: 'نام صفحه',
        cost: 'قیمت (تومان)',
        followers: 'تعداد دنبال کننده',
        userEngagement: 'نرخ مشارکت کاربران',
        select: ''
      },
      selectPage: 'انتخاب صفحه'
    },
    profile: {
      title: 'حساب کاربری'
    },
    logout: {
      title: 'خروج از حساب'
    },
    reports: {
      title: 'گزارش',
      tableHeader: {
        name: 'نام',
        email: 'ایمیل',
        amount: 'مقدار',
        phone: 'شماره تماس',
        startDate: 'تاریخ شروع',
        endDate: 'تاریخ پایان',
        actions: 'عملیات',
        show: ''
      },
      campaignTypes: {
        type1: 'نوع ۱',
        type2: 'نوع ۲',
        type3: 'نوع ۳'
      },
      show: 'نمایش جزییات',
      campaignTypePlaceholder: 'نوع کمپین',
      genderPlaceholder: 'جنسیت',
      ageRangePlaceholder: 'بازه سنی',
      female: 'زن',
      male: 'مرد'
    },
    about: {
      title: 'درباره ما'
    },
    changes: {
      title: 'تغییرات'
    },
    dashboard: {
      title: 'داشبورد'
    },
    datepicker: {
      title: 'انتخابگر زمان'
    },
    forgotpass: {
      title: 'فراموشی رمز عبور'
    },
    index: {
      title: 'خانه'
    },
    login: {
      title: 'ورود'
    },
    register: {
      title: 'ثبت نام'
    },
    changePassword: {
      title: 'تغییر گذرواژه'
    },
    chat: {
      title: 'گفتگو ها',
      searchInChat: 'جستجو در گفتگوها',
      sendMessage: 'ارسال پیام',
      typeMessage: 'پیام خود را تایپ کنید',
      today: 'امروز',
      yesterday: 'دیروز'
    },
    starter: {
      title: 'شروع کننده'
    },
    forms: {
      title: 'فرم ها',
      typeSelectLabel: 'حالت فرم',
      nameTextLabel: 'v-text-field',
      nameTextPlaceholder: 'نام',
      nameTextRuleRequired: 'نام الزامی می باشد',
      nameTextRuleMaxLength: 'تعداد کاراکتر مجاز نام حداکثر ۱۰ می باشد',
      mailTextLabel: 'v-text-field (ltr)',
      mailTextPlaceholder: 'email',
      mailTextSlotLabel: 'v-text-field (slot)',
      shebaTextLabel: 'v-text-field (suffix)',
      shebaTextPlaceholder: '** **** **** **** **** **** **',
      shebaSuffix: 'IR',
      shebaRuleLength: 'شماره شبا باید دقیقا ۲۴ رقم باشد',
      shebaRuleOnlyNumber: 'شماره شبا باید مقدار عددی باشد',
      descTextareaLabel: 'v-textarea',
      descTextareaPlaceholder: 'توضیحات',
      itemSelectLabel: 'v-select',
      itemSelectPlaceholder: 'انتخاب کنید',
      itemSelectRuleRequired: 'انتخاب آیتم الزامی می باشد',
      itemSelectMultipleLabel: 'v-select (multiple)',
      itemSelectMultiplePlaceholder: 'انتخاب (چندتایی)',
      itemMultiselectLabel: 'Multiselect',
      itemMultiselectPlaceholder: 'انتخاب آیتم ها',
      datePickerLabel: 'date-picker',
      datetimePickerLabel: 'datetime-picker',
      timePickerLabel: 'time-picker',
      counterSliderLabel: 'v-slider',
      agreeCheckboxLabel: 'v-checkbox',
      agreeCheckboxRuleRequired: 'برای ادامه باید قبول کنید',
      agreeSwitchLabel: 'v-switch',
      agreeSwitchRuleRequired: 'برای ادامه لطفا فعال کنید',
      genderRadioLabel: 'v-radio',
      genderRadioOptionMale: 'مرد',
      genderRadioOptionFemale: 'زن',
      genderRadioRuleRequired: 'لطفا جنسیت خود را انتخاب کنید',
      docFileLabel: 'v-file-input',
      docFilePlaceholder: 'انتخاب تصویر',
      submitButtonText: 'ثبت',
      cancelButtonText: 'لغو',
      removeButtonText: 'حذف',
      sendButtonText: 'ارسال',
      returnButtonText: 'بازگشت',
      comboboxChipsLabel: 'combobox chips',
      autocompleteLabel: 'autoComplete'
    },
    forgotPass: {
      title: 'فراموشی رمز عبور',
      email: 'پست الکترونیک',
      submit: 'ارسال',
      cancel: 'بازگشت'
    },
    authenticationDetails: {
      title: 'پیام ها',
      registerTitle: 'اطلاعات شما با موفقیت ثبت شد',
      registerDescription: 'پیام تایید به پست الکترونیکی شما ارسال شد',
      registerDetails: 'مراحل تایید :',
      registerDetails1: '1. وارد پست الکترونیکی که در هنگام ثبت نام ثبت کرده اید شوید .',
      registerDetails2: '2. پیام تاییدی را که از دیما دریافت کردید باز کنید.',
      registerDetails3: '3. روی لینک کلیک کنید.',
      changePasswordTitle: 'تغییر کلمه عبور',
      changePasswordDescription: 'کلمه عبور شما با موفقیت تغییر یافت',
      login: 'ورود'
    },
    globalSnackbar: {
      title: 'ناتیفیکیشن',
      showSnackbar: 'نمایش پیام'
    },
    underConstruction: {
      title: 'در حال ساخت'
    }
  }
}
